import { useEffect } from 'react';

export default function SEOHelper({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | MADAD`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
  }, [title, description]);

  return null;
}